import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, Home } from "lucide-react";
import { LogoMark } from "@/components/brand";

const LINKS = [
  { to: "/experiences", label: "Experiences" },
  { to: "/membership", label: "Membership" },
  { to: "/gallery", label: "Gallery" },
  { to: "/resort-guide", label: "Resort Guide" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

// Public navigation for authentication pages so visitors are never trapped.
export default function AuthNav() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  return (
    <>
      <header className="absolute top-0 inset-x-0 z-40" data-testid="auth-nav">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
          <Link to="/" data-testid="auth-nav-logo"><LogoMark className="h-10 w-10" withText size="text-lg" /></Link>
          <nav className="hidden lg:flex items-center gap-6">
            {LINKS.map((n) => (
              <Link key={n.label} to={n.to} data-testid={`auth-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-xs tracking-label uppercase text-foreground/70 hover:text-gold transition-colors">{n.label}</Link>
            ))}
          </nav>
          <div className="hidden lg:flex items-center gap-3">
            <Link to="/" data-testid="auth-nav-home" className="text-xs tracking-label uppercase text-foreground/70 hover:text-gold flex items-center gap-1.5"><Home size={13} /> Return Home</Link>
            <button onClick={() => nav("/book")} data-testid="auth-nav-reserve" className="btn-gold px-5 py-2 text-xs">Reserve</button>
          </div>
          <button className="lg:hidden text-gold" onClick={() => setOpen(true)} data-testid="auth-nav-mobile-open"><Menu /></button>
        </div>
      </header>

      {open && (
        <div className="fixed inset-0 z-50 bg-ink/95 backdrop-blur-xl flex flex-col p-6 lg:hidden" data-testid="auth-mobile-menu">
          <div className="flex items-center justify-between mb-10">
            <LogoMark className="h-10 w-10" withText size="text-lg" />
            <button onClick={() => setOpen(false)} className="text-gold" data-testid="auth-nav-mobile-close"><X /></button>
          </div>
          <nav className="flex flex-col gap-6">
            {LINKS.map((n) => (
              <Link key={n.label} to={n.to} onClick={() => setOpen(false)} className="font-serif text-2xl text-foreground/90 hover:text-gold">{n.label}</Link>
            ))}
          </nav>
          <div className="mt-auto flex flex-col gap-3">
            <button onClick={() => { setOpen(false); nav("/"); }} className="btn-ghost-gold py-3">Return Home</button>
            <button onClick={() => { setOpen(false); nav("/book"); }} className="btn-gold py-3">Reserve</button>
          </div>
        </div>
      )}
    </>
  );
}
